import { axios } from "utils";

import { PUBLIC_VERIFICATIONS_URL as endpoint } from "consts";

import { GetVerificationEditingRequestsResponse, UpdateEditingRequestRequestBody, VerificationsFarmTasks } from "models";

export const getAllUserVerificationFarmTasks = async (data: { farmId: string }): Promise<VerificationsFarmTasks[]> =>
  axios.get(`${endpoint}/farms/tasks`, { data });

export const updateUserVerificationFarmTask = async (data: { id: string; signal: AbortSignal }) =>
  axios.put(`${endpoint}/farms/tasks/${data.id}`, { data, signal: data.signal });

export const getFarmPayoutApprovals = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/farms/payout-approvals`, { data });

export const getFieldModuleVerifications = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/field-modules`, { data });

// editing requests

export const updateVerificationEditingRequest = async (data: UpdateEditingRequestRequestBody) => axios.put(`${endpoint}/editing-requests/${data.id}`, { data });

export const getVerificationEditingRequests = async (data: { farmId: string }): Promise<GetVerificationEditingRequestsResponse> =>
  axios.get(`${endpoint}/farms/${data.farmId}/editing-requests`, { data });
